export default __webpack_public_path__ + "de63296c104e0907660c9cab93960780.png";